import Identified from "../../types/base/Identified";

const primaryEntityComparator =
  (primaryEntityId?: Identified["id"]) => (a: Identified, b: Identified) =>
    a.id === primaryEntityId ? -1 : b.id === primaryEntityId ? 1 : 0;

export default primaryEntityComparator;
